import { Typography } from "@sunrun/experience-ui-components";
// eslint-disable-next-line import/no-restricted-paths
import { OneListView } from "./OneListView";
import { useUserProfile } from "providers/UserProfile";

const Customers = () => {
  const { userProfile } = useUserProfile();
  const { contactId, email } = userProfile;

  if (!contactId || !email) {
    return <Typography>Loading...</Typography>;
  }

  return <OneListView />;
};

export { Customers };
